var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRestaurauntGradeHardware = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#5069C3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M49.5 46.5c2-2.4 3-4.8 3-7v-28l-20-4-20 4v28c0 2.2 1.1 4.5 3 7 0 0 7 7 17 11 0 0 11-4 17-11"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF4C00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M44.1 42c1.4-1.6 2-3.3 2-5.5v-19l-13.6-2.8-13.6 2.8v19.8c0 1.5.7 3.1 2 4.8 0 0 4.8 4.8 11.6 7.5 0-.1 7.5-2.8 11.6-7.6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF4C00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "m26.5 30.5 5 5 8-9"
})));
export { SvgRestaurauntGradeHardware as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ5LjUgNDYuNUM1MS41IDQ0LjEgNTIuNSA0MS43IDUyLjUgMzkuNVYxMS41TDMyLjUgNy41TDEyLjUgMTEuNVYzOS41QzEyLjUgNDEuNyAxMy42IDQ0IDE1LjUgNDYuNUMxNS41IDQ2LjUgMjIuNSA1My41IDMyLjUgNTcuNUMzMi41IDU3LjUgNDMuNSA1My41IDQ5LjUgNDYuNVoiIHN0cm9rZT0iIzUwNjlDMyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDQuMDk5OSA0Mi4wMDAyQzQ1LjQ5OTkgNDAuNDAwMiA0Ni4wOTk5IDM4LjcwMDIgNDYuMDk5OSAzNi41MDAyVjE3LjUwMDJMMzIuNDk5OSAxNC43MDAyTDE4Ljg5OTkgMTcuNTAwMlYzNy4zMDAyQzE4Ljg5OTkgMzguODAwMiAxOS41OTk5IDQwLjQwMDIgMjAuODk5OSA0Mi4xMDAyQzIwLjg5OTkgNDIuMTAwMiAyNS42OTk5IDQ2LjkwMDIgMzIuNDk5OSA0OS42MDAyQzMyLjQ5OTkgNDkuNTAwMiAzOS45OTk5IDQ2LjgwMDIgNDQuMDk5OSA0Mi4wMDAyWiIgc3Ryb2tlPSIjRkY0QzAwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDMwLjVMMzEuNSAzNS41TDM5LjUgMjYuNSIgc3Ryb2tlPSIjRkY0QzAwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";